// Custom hook to prompt alert in case that user is trying to leave
// the page. Modern browsers consider setting custom messages a security issues
// so it's disabled in newer version. There is a better solution for this with react-router Prompt
// but, until this A1000 is made into SPA, we can't use it.
import { useEffect } from "react";

const useExitPrompt = (condition = true) => {
  useEffect(() => {
    if (condition) {
      window.onbeforeunload = () => true;
    }
    return () => {
      window.onbeforeunload = null;
    };
  }, [condition]);
};

export default useExitPrompt;
